import { render, staticRenderFns } from "./EmailTechpacks.vue?vue&type=template&id=7964270b&scoped=true"
import script from "./EmailTechpacks.vue?vue&type=script&lang=ts"
export * from "./EmailTechpacks.vue?vue&type=script&lang=ts"
import style0 from "./EmailTechpacks.vue?vue&type=style&index=0&id=7964270b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7964270b",
  null
  
)

export default component.exports